import { Box, ButtonNew, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { FC } from 'react'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { DropdownTypes } from '../../comps/DropdownNew/types'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { dataExport } from '../../data/static/data'
import { transactionDetailsStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'
import { Colors } from '../../util/util'
interface HeaderProps {
  title: string
  onDuplicate?: () => void
  isDetailsScreen?: boolean
  onExport?: (type: string, id: string) => void
  status?: string
  canCreateCampaigns?: boolean
  onProceed: any
  okTitle?: string
  cancelTitle?: string
  onPause?: any
  onStop?: any
  apiState: boolean
}

const IS_EXPORT_ENABLED = false

const Header: FC<HeaderProps> = ({
  title,
  isDetailsScreen = false,
  onExport,
  status,
  canCreateCampaigns = false,
  onProceed,
  okTitle = '',
  cancelTitle = '',
  onPause,
  onStop,
  apiState,
}: HeaderProps) => {
  const onEdit = () => {
    status !== 'COMPLETED' && onProceed && onProceed(false)
  }

  const onDuplicate = () => {
    onProceed && onProceed(true)
  }

  const titles: any = {
    ACTIVE: 'Pause',
    INACTIVE: 'Resume',
    SCHEDULED: 'Pause',
    PAUSED: 'Resume',
    COMPLETED: 'Resume',
  }

  const actions: any = {
    ACTIVE: 1,
    INACTIVE: 3,
    SCHEDULED: 1,
    PAUSED: 3,
    COMPLETED: 3,
  }

  const navigation = useNavigation()
  return (
    <Box
      w="100%"
      p={24}
      borderBottomWidth={1}
      borderBottomColor={'#0000001F' as ColorOptions}
      justifyContent="space-between"
      flexDirection="row"
      align="center">
      <Box flexDirection={'row'}>
        <Text fontSize="FONT_SIZE_LARGE_PLUS" color="BLACK_21" fontFamily="jiotype-bold">
          {title}
        </Text>
        <Spacer size={8} direction="horizontal" />
        <ModBox ph={8} pv={6} borderRadius={4} bg={Colors.GREEN_BG_C as ColorOptions} show={!!status}>
          <Text fontSize={12} color={Colors.GREEN_C as ColorOptions} fontFamily="jiotype-medium">
            {status}
          </Text>
        </ModBox>
      </Box>
      <Spacer size={8} direction="horizontal" />
      <ModBox flexDirection={'row'} show={!isDetailsScreen && canCreateCampaigns}>
        <ButtonNew
          type="secondary"
          onPress={() => (navigation?.canGoBack() ? navigation.goBack() : navigation?.navigate(Routes.CAMPAIGNS))}
          title={cancelTitle}
          borderColor={'BLUE'}
          titleColor={'BLUE'}
          height={40}
          width={180}
          hide={cancelTitle?.length === 0}
          shadowType={'shadowSecondary'}
        />
        <Spacer direction="horizontal" size={16} />
        <ButtonNew
          type="primary"
          onPress={onProceed}
          title={okTitle}
          height={40}
          width={180}
          isLoading={apiState}
          disabled={apiState}
        />
      </ModBox>
      <ModBox flexDirection={'row'} show={isDetailsScreen && canCreateCampaigns} gap={8}>
        <ButtonNew type="primary" onPress={onDuplicate} title={'Duplicate'} height={40} width={180} />
        <ButtonNew type="primary" onPress={onEdit} title={'Edit Campaign'} height={40} width={180} hide={status === 'COMPLETED'}/>
        <ButtonNew type="primary" onPress={onPause} title={titles[status] ?? 'Pause'} height={40} hide={status === 'COMPLETED'}/>
        <ButtonNew type="primary" onPress={onStop} title={'Stop'} height={40} hide={status === 'COMPLETED'}/>
        {IS_EXPORT_ENABLED && (
          <>
            <Spacer size={16} direction="horizontal" />
            <DropdownOptimised
              placeHolder={transactionDetailsStrings.export}
              onChange={() => {}}
              disabled={status === 'COMPLETED'}
              data={dataExport}
              type={DropdownTypes.RADIO_BUTTON}
              onButtonPress={(type: any) => onExport && onExport(type, title)}
              testID={'campaignExport'}
            />
          </>
        )}
      </ModBox>
    </Box>
  )
}

export { Header }
